<template>
  <div class="judge judge-bg">
    <div class="title">
			<p style="height: 55px;"></p>
			<!-- <img style="width:366px" src="../../assets/image/match/judge-title.png" alt=""> -->
		</div>
    <div class="jd-carousel-box">
			<carousel-3d v-if="imgList.length" :autoplay="true" :inverseScaling="5" :autoplayTimeout="300000" :border="0" :perspective="0"
				:display="7" :animationSpeed="1000" :width="236" :height="245" controlsVisible :controlsHeight="60">
				<slide v-for="(item, i) in imgList" :index="i" :key="i">
					<template slot-scope="obj">
						<div style="position:relative" class="img-wrap">
							<!-- <img :src="`http://i.didaward.cn/prod-api${item.expePhoto}`" @click="imgClick(item, obj, i)" /> -->
							<div class="img" :style="{'background-image': `url(http://i.didaward.cn/prod-api${item.expePhoto}`}" @click="imgClick(item, obj, i)" />
							<div class="infor-box">
								<div class="name">{{ item.expeName }}</div>
								<!-- <div class="name2">{{ item.expeName }}</div> -->
							</div>
						</div>
					</template>
				</slide>
			</carousel-3d>
    </div>
    <div v-show="false" class="inf" style="width:100%;height:200px">
			<div class="inf-text">
				<div>{{ name }}</div>
				<div>{{ des }}</div>
			</div>
    </div>
		<div class="more-infor-line">
			<a @click="go" href="javascript:void(0);" class="more-btn">更多历届专家详细&gt;&gt;&gt;</a>
		</div>
</div>
</template>

<script>
import { getExportList } from "@/api/api.js";
export default {
	name: "judge",
	data() {
		return {
			imgList: [],
			name: '',
			des: '',
			imgindex: 0
		};
	},
	methods: {
		onSlideChange(i) {
			console.log('onSlideChange', i);
		},
		go() {
			this.$router.push('Export')
		},
		imgClick(data, obj, i) {
			this.name = data.expeName
			this.des = data.expePost
			this.imgindex = i
		},
		getInf() {
			setInterval(() => {
				if (this.imgindex < this.imgList.length) {
					this.name = this.imgList[this.imgindex].expeName
					this.des = this.imgList[this.imgindex].expePost
					this.imgindex += 1
				} else {
					this.imgindex = 0
				}
			},3800);
		},
		getList() {
      getExportList({pageNum: 1, pageSize: 100, expeType: '4'}).then((res) => {
				this.imgList = (res.data).rows || [];
				// this.getInf()
      });
    },
	},
	created() {

	},
	mounted() {
		this.getList();
	},
}
</script>

<style lang="scss" scoped>
.judge {
  // background: url('../../assets/image/match/judge-bg.jpg') no-repeat center top;
	height: 800px;
	.title {
		text-align: center;
		margin-bottom: 70px;
		padding-top: 145px;
	}

	.text {
		// text-align: center;
		margin: auto;
		width: 580px;
		// font-weight: bold;
		line-height: 50px;
		text-indent: 2em;
		font-size: 25px;
		color: rgb(31, 0, 2)
	}

	.name {
		position: absolute;
		width: 100%;
		height: 45px;
		background-color: rgba(0, 0, 0, .5);
		color: white;
		bottom: 0;
		font-weight: bold;
		text-align: center;
		line-height: 45px;
	}

	.inf {
		// background: url('../../assets/image/match/judge-text-bg.jpg');
		background: #f6f1e6;
		height: 289px;
		.inf-text {
			width: 800px;
			margin: auto;
			color: rgb(30, 0, 0);
			padding-top: 1px;

			div:nth-child(1) {
					font-weight: bold;
					font-size: 20px;
					margin-top: 100px;
					margin-bottom: 20px;
			}

			div:nth-child(2) {
				line-height: 10px;
			}
		}
	}
}
.more-infor-line {
	.more-btn {
		display: block;text-align: center;font-size: 16px;
	}
	padding: 20px 0;
	width: 460px;
	margin: auto;
	// border-bottom: 26px solid #25877d;
}
.img-wrap {
	height: 245px;width: 236px;overflow: hidden;
	img, .img {height: 200px;}
	.img {
		// aspect-ratio: 282/199;
    background-size: cover;
		background-position: center;
    background-repeat: no-repeat;
	}
	.infor-box {
		// padding: 16px 12px;
		// box-sizing: border-box;height: 100px;
    // background: #F9F9F9;
	}
}
.jd-carousel-box {height: 380px;padding-top: 20px;}
</style>
<style lang="scss" >

.jd-carousel-box .prev, .jd-carousel-box .next {color: #c7ad89;}
</style>



// WEBPACK FOOTER //
// src/components/Match/judge.vue